import { render, staticRenderFns } from "./mobileTopBigPic.vue?vue&type=template&id=7c48c8b0&scoped=true&"
import script from "./mobileTopBigPic.vue?vue&type=script&lang=js&"
export * from "./mobileTopBigPic.vue?vue&type=script&lang=js&"
import style0 from "./mobileTopBigPic.vue?vue&type=style&index=0&id=7c48c8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48c8b0",
  null
  
)

export default component.exports